// src/pages/HoldThenPage.js

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import SEO from '../components/SEO';
import {
  Page,
  Container,
  Breadcrumb,
  Header,
  HeaderLogo,
  Eyebrow,
  Title,
  Lead,
  Section,
  SectionTitle,
  CardGrid,
  Card,
  ButtonRow,
  PrimaryLink,
  InlineLinks,
  Faq
} from '../components/ContentPage';
import { holdThenFacts, holdThenFaq, siteMeta } from '../seo/siteMeta';

const HoldThenPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO routeKey="holdThen" />
      <Page>
        <Container>
          <Breadcrumb items={[{ label: 'Home', to: '/' }, { label: 'HoldThen' }]} />

          <Header>
            <HeaderLogo
              src="/logo-holdthen-icon.webp"
              alt="HoldThen logo"
              width="96"
              height="96"
              style={{ background: 'var(--white)' }}
            />
            <div>
              <Eyebrow $color="#F5A066">Waitlist open</Eyebrow>
              <Title>HoldThen: B2B international logistics platform</Title>
              <Lead>
                HoldThen unifies package forwarding, consolidation, inventory, billing, and
                end-to-end shipment tracking in one workflow for logistics businesses. It is built
                by XADevs LLC and has not launched yet; the waitlist is open on holdthen.com.
              </Lead>
            </div>
          </Header>

          <ButtonRow>
            <PrimaryLink
              href={siteMeta.productUrls.holdThenWebsite}
              target="_blank"
              rel="noopener"
              $color="#B4561A"
            >
              Join the waitlist at holdthen.com <FiArrowRight aria-hidden="true" />
            </PrimaryLink>
          </ButtonRow>

          <Section aria-labelledby="features-heading">
            <SectionTitle id="features-heading">What HoldThen covers</SectionTitle>
            <CardGrid>
              {holdThenFacts.features.map((feature) => (
                <Card key={feature.title}>
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </Card>
              ))}
            </CardGrid>
          </Section>

          <Section aria-labelledby="faq-heading">
            <SectionTitle id="faq-heading">Frequently asked questions</SectionTitle>
            <Faq items={holdThenFaq} />
          </Section>

          <Section aria-labelledby="more-heading">
            <SectionTitle id="more-heading">More from XADevs</SectionTitle>
            <InlineLinks>
              <Link to="/about">About XADevs</Link>
              <Link to="/volpetrack">VolpeTrack</Link>
              <Link to="/support">Support Center</Link>
            </InlineLinks>
          </Section>
        </Container>
      </Page>
    </>
  );
};

export default HoldThenPage;
